// Cifras de MUESTRA de la landing pública (demos ilustrativas): no son datos de ningún usuario,
// por eso no pasan por <Monto>.
export const pesos = (n) => `$${Number(n).toLocaleString('en-US')}`; // monto-ok: cifras de muestra de la landing pública, no son datos del usuario
